import { useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const db = firebase.firestore();
const LS_KEY = 'lastSeenNewsDate';

export const useNewsNotification = () => {
  const [hasUnread, setHasUnread] = useState(false);

  useEffect(() => {
    db.collection('updates')
      .where('active', '==', true)
      .orderBy('date', 'desc')
      .limit(1)
      .get()
      .then(snap => {
        if (snap.empty) return;
        const latest = snap.docs[0].data().date.seconds;
        const seen = parseInt(localStorage.getItem(LS_KEY) || '0', 10);
        setHasUnread(latest > seen);
      })
      .catch(() => {});
  }, []);

  return hasUnread;
};

export const markNewsAsSeen = (latestSeconds) => {
  localStorage.setItem(LS_KEY, String(latestSeconds));
};
